export class Gerencial {}
